<template>
  <div
    :class="`m-modal m-modal-- ${active ? 's-active' : ''}`"
    data-modal-dialog=""
    role="dialog"
    aria-modal="true"
    v-show="active"
  >
    <div class="m-modal__dialog" role="document">
      <DidacticStory :showId="shownId">
        <slot />
      </DidacticStory>
      <footer>
        <StyledButton
          v-if="!isFirst"
          :onClick="previous"
          small
          icon="arrow-left"
        >
          Previous
        </StyledButton>
        <StyledButton
          v-if="!isLast"
          :onClick="next"
          primary
          small
          icon="arrow-right"
        >
          Next
        </StyledButton>
        <StyledButton :onClick="close" primary dark small icon="sm-close">
          Close
        </StyledButton>
      </footer>
    </div>
  </div>
</template>

<script>
import { StyledButton } from "@international-energy-agency/vue-ui";
import DidacticStory from "./DidacticStory.vue";
export default {
  name: "DidacticModal",
  components: {
    StyledButton,
    DidacticStory,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentIndex: 0,
    };
  },
  computed: {
    storyIds() {
      return this.$slots.default.map((child) => child.data.attrs.id);
    },
    shownId() {
      return this.storyIds[this.currentIndex];
    },
    isFirst() {
      return this.currentIndex === 0;
    },
    isLast() {
      return this.currentIndex === this.storyIds.length - 1;
    },
  },
  methods: {
    next() {
      this.currentIndex += 1;
    },
    previous() {
      this.currentIndex -= 1;
    },
    close() {
      this.$emit("modal:close");
    },
  },
};
</script>
<style scoped>
.m-modal__dialog {
  height: 100%;
}
.m-modal__dialog footer {
  border-top: 1px solid #e6e6e6;
  margin-top: 16px;
  padding: 12px;
  display: flex;
  justify-content: flex-end;
}
.m-modal__dialog footer > *:not(:last-child) {
  margin-right: 12px;
}
.m-modal__dialog > div {
  padding: 24px;
  max-height: calc(95vh - 80px);
  overflow: auto;
}
.m-modal {
  max-height: 95vh;
  top: 2.5vh;
  opacity: 1;
  visibility: visible;
  overflow: hidden;
}
@media screen and (min-width: 730px) {
  .m-modal {
    max-height: 100%;
    /*top: 8% !important;*/
    width: 600px;
    margin-left: -300px;
  }
}
@media screen and (max-width: 730px) {
  .m-modal {
    width: 100vw;
    height: 100vh;
    top: 0px;
  }
  .m-modal__dialog > div {
    max-height: calc(100vh - 80px);
  }
}
.m-modal.s-active {
  transform: translateZ(0);
  transition: transform 0.2s linear;
}
</style>
